// extracted by mini-css-extract-plugin
export default {"saved-items":"GlobalSavedItems___style-module__saved-items___3DZIU","saved-label":"GlobalSavedItems___style-module__saved-label___kKa-f"};